//#region ../../packages/components/scrollbar/src/constants.ts
const scrollbarContextKey = Symbol("scrollbarContextKey");

//#endregion
export { scrollbarContextKey };
//# sourceMappingURL=constants.mjs.map